import { Button, Modal } from "antd";

const PatientEditModal = ({
  open,
  patient,
  loading,
  onCancel,
  onChange,
  onSubmit,
  isAddMode = false,
}) => {
  return (
    <Modal
      title={isAddMode ? "Add New Patient" : "Edit Patient"}
      open={open}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" loading={loading} onClick={onSubmit}>
          {isAddMode ? "Add" : "Update"}
        </Button>,
      ]}
      width={500}
    >
      {patient && (
        <form className="flex flex-col gap-3">
          <input
            type="text"
            value={patient.patientName || ""}
            onChange={(e) => onChange("patientName", e.target.value)}
            placeholder="Name"
            className="border p-2 rounded"
          />
          <input
            type="text"
            value={patient.mobile || ""}
            onChange={(e) => onChange("mobile", e.target.value)}
            placeholder="Mobile"
            className="border p-2 rounded"
          />
          <input
            type="number"
            value={patient.age || ""}
            onChange={(e) => onChange("age", e.target.value)}
            placeholder="Age"
            className="border p-2 rounded"
          />
          <input
            type="text"
            value={patient.gender || ""}
            onChange={(e) => onChange("gender", e.target.value)}
            placeholder="Gender"
            className="border p-2 rounded"
          />
          <input
            type="text"
            value={patient.address || ""}
            onChange={(e) => onChange("address", e.target.value)}
            placeholder="Address"
            className="border p-2 rounded"
          />
        </form>
      )}
    </Modal>
  );
};

export default PatientEditModal;
